

export default class Constants {
  static subfolder = process.env.REACT_APP_SUBFOLDER;
  static apiBaseUrl = process.env.REACT_APP_API_BASEURL;
  static tenantUrl = process.env.REACT_APP_BASEURL;
  static mapUrl = process.env.REACT_APP_MAP
  // static apiBaseUrl = process.env.REACT_APP_PAYSTACK_BASEURL;

  static defaultModalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "visible",
      zIndex: 1000,
    },
  };
}
